import { render, staticRenderFns } from "./ModalInsufficientCreditViralClone.vue?vue&type=template&id=8667aea4&"
import script from "./ModalInsufficientCreditViralClone.vue?vue&type=script&lang=js&"
export * from "./ModalInsufficientCreditViralClone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports